import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindCatalogueLandingContent
{
  queryCatalogueLandingContents {
    data {
      pageTitle { iv }      

      intro {
        iv{id}
      }

      carrousel {
        iv{id}
      }

      tendance {
        iv{id}
      }

      promo {
        iv{id}
      }

      seoDescription { iv }
      seoKeywords { iv }
      seoThumbnail {
        iv {
          url
        }
      }
    }
  }
}
`,
]);
